export class PasswordExtraForDataExport_v1 {
    name: string;
    data: string;
}